export default {
    id:     '',
    isPlay: false,
    isShow: false,
    record: '',
    state:  'off',
};
